<form
  class="easy-form"
  [formGroup]="registrationForm"
  appScrollToInvalidControl
  autocomplete="on"
>
  <h1 class="my-0">
    {{ TITLE + "REGISTRATION" | translate | uppercase }}
  </h1>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'COMPANY_NAME'"
        [placeholder]="PLACEHOLDER + 'COMPANY_NAME'"
        formControlName="companyName"
        [autocomplete]="'organization'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'BRAND_NAME'"
        [placeholder]="PLACEHOLDER + 'BRAND_NAME'"
        formControlName="brandName"
        [autocomplete]="'organization'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'TAX_NUMBER'"
        [placeholder]="PLACEHOLDER + 'TAX_NUMBER'"
        formControlName="taxNumber"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'EMAIL'"
        [placeholder]="PLACEHOLDER + 'EMAIL'"
        formControlName="email"
        [autocomplete]="'email'"
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-phone-subform
        formControlName="phone"
        [label]="TITLE + 'PHONE'"
        [placeholder]="PLACEHOLDER + 'PHONE'"
      ></app-easy-phone-subform>
    </mat-form-field>

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'PROMOTION_CODE'"
        formControlName="promotionCode"
        [autocomplete]="'promotionCode'"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <mat-form-field>
    <!-- mat-form-field kell majd a teljes form átalakításkor, addig az invalid állapot nem jó,
      de a validator így is teljesíti a funkció szerinti működést -->
    <app-easy-checkbox formControlName="termsAndConditions">
      <span #content>
        {{ TITLE + "TERMS_AND_CONDITIONS.0" | translate }}
        <a
          href="{{ documentsStorageUrl }}/TermsAndConditions.pdf"
          target="_blank"
        >
          <span translate>{{ TITLE + "TERMS_AND_CONDITIONS.1" }}</span>
        </a>
        <span translate>{{ TITLE + "TERMS_AND_CONDITIONS.2" }}</span>
      </span>
    </app-easy-checkbox>
  </mat-form-field>

  <div>
    <mat-form-field>
      <app-easy-checkbox formControlName="privacyConditions">
        <span #content>
          {{ TITLE + "PRIVACY_CONDITIONS.0" | translate }}
          <a href="{{ documentsStorageUrl }}/PrivacyPolicy.pdf" target="_blank">
            <span translate>{{ TITLE + "PRIVACY_CONDITIONS.1" }}</span>
          </a>
          <span translate>{{ TITLE + "PRIVACY_CONDITIONS.2" }}</span>
        </span>
      </app-easy-checkbox>
    </mat-form-field>
    <mat-error
      *ngIf="
        (this.registrationForm.get('termsAndConditions')?.touched &&
          this.registrationForm.get('termsAndConditions')?.invalid) ||
        (this.registrationForm.get('privacyConditions')?.touched &&
          this.registrationForm.get('privacyConditions')?.invalid)
      "
      class="mat-error"
    >
      {{ "REGISTRATION.HINT.TAC_AND_PRIVACY" | translate }}
    </mat-error>
  </div>

  <button mat-raised-button color="primary" (click)="onSubmit()">
    {{ "REGISTRATION.BTN.CONTINUE" | translate | uppercase }}
  </button>
</form>
